import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import 'semantic-ui-css/semantic.min.css';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import "semantic-ui-css/semantic.min.css";
import './auth.css';
import { BrowserRouter, Route, Switch,Redirect } from 'react-router-dom';
import Login from './authentication/login.js';
import Forget from './authentication/forget.js';
import Code from './authentication/code.js';
import ContactUS from './authentication/contact_us.js';
import ContactUSType from './authentication/contact_us_type.js';
import MenuSideWeb from './components/side_menu_web.js';
import Menutest from './components/menu.js';
import Profile from './components/profile.js';
import Contact from './components/contact.js';
import Group from './components/group.js';
import Category from './components/category.js';
import BulkSMS from './components/bulksms.js';
import Request from './components/request.js';
import ConatctUSView from './components/contacts_us_view';
import RequestBalance from './components/request_balance.js';
import ViewForm from './components/ViewForm.js';
import Dashboardnew from './components/Dashboardnew';
import AddContact from './components/add_contact';
import EditContact from './components/edit_contact';
import ImportContact from './components/import';
import AddForm from './components/add_form';
import Adds from './components/adds';
import MenuSideWebCMS from './components/side_menu_web_cms.js';
import AddAds from './components/add_adv.js';
import EditAds from './components/edit_adv.js';
import ReportBulk from './components/bulkreport.js';
import Landing from './components/landing.js';
import Test from './components/test.js';
import AddGroup from './components/add_group';
import EditGroup from './components/edit_group';
import AddCategory from './components/add_category';
import EditCategory from './components/edit_category';
import AddBalance from './components/add_balance';
import EditForm from './components/edit_form';
import Balance from './components/balance';
import SenderID from './components/sender_id';
import AddSenderID from './components/addsender_id';
import EditSenderID from './components/editsender_id';
import AddRequestSenderID from './components/add_request.js';
import AddRequestBalance from './components/add_request_balance.js';
import Template from './components/template.js';
import AddTemplate from './components/add_template.js';
import EditTemplate from './components/edit_template.js';
import Promotion from './components/promotion.js';
import AddPromotion from './components/add_promotion';
import EditPromotion from './components/edit_promotion';
import Animation from './components/animation';
import Settings from './components/Setting'
import EditorConvertToHTML from './components/editor'
import Profiled from './components/profiled'
import MigrationData from './components/MigrationData.js';
import  JobDetails  from "./components/JobDetails.js";
import IntegrationSMS from './components/IntegrationSMS'
import SenderIdSetting from './components/senderid_setting'
import Invoices from './components/invoices'

import Map from './components/Map'
import LBA from './components/LBA'
import MyMap from './components/mymap'
import GoogelUser from './components/mapGoogel'
import AddArea from './components/AddArea'

import InternationalSMS from './components/international'
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import reducers from './reducers';
// import 'react-app-polyfill/ie9';
// import 'react-app-polyfill/ie11';
import 'raf/polyfill';
import 'core-js/es/map';
import 'core-js/es/set';
import { reactLocalStorage } from 'reactjs-localstorage';




import SubAdminJobs from './components/subAdminJobs'
import JobsHistory from './components/jobsHistory'

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
<Provider store={createStore(reducers)}>
<BrowserRouter>
<div className={reactLocalStorage.get('lang')==="en"?"englishFont":"arabicFont"} >
<Switch>

<Route path="/app/Forget" component={Forget}/>
<Route path="/app/Code" component={Code}/>
<Route path="/app/Animation" component={Animation}/>
<Route path="/app/ContactUS" component={ContactUS}/>
<Route path="/app/ContactUSType" component={ContactUSType}/>
<Route path="/app/ConatctUSView" component={ConatctUSView}/>
<Route path="/app/RequestBalance" component={RequestBalance}/>
<Route path="/app/Template" component={Template}/>
<Route path="/app/AddTemplate" component={AddTemplate}/>
<Route path="/app/EditTemplate" component={EditTemplate}/>
<Route path="/app/Promotion" component={Promotion}/>
<Route path="/app/AddPromotion" component={AddPromotion}/>
<Route path="/app/EditPromotion" component={EditPromotion}/>
<Route path="/app/AddRequestSenderID" component={AddRequestSenderID}/>
<Route path="/app/AddRequestBalance" component={AddRequestBalance}/>
<Route path="/app/AddContact" component={AddContact}/>
<Route path="/app/Landing" component={Landing}/>
<Route path="/app/SenderID" component={SenderID}/>
<Route path="/app/AddSenderID" component={AddSenderID}/>
<Route path="/app/EditSenderID" component={EditSenderID}/>
<Route path="/app/test" component={Test}/>
<Route path="/app/ReportBulk" component={ReportBulk}/>
<Route path="/app/Adds" component={Adds}/>
<Route path="/app/Balance" component={Balance}/>
<Route path="/app/AddAds" component={AddAds}/>
<Route path="/app/EditAds" component={EditAds}/>
<Route path="/app/AddForm" component={AddForm}/>
<Route path="/app/EditForm" component={EditForm}/>
<Route path="/app/EditContact" component={EditContact}/>
<Route path="/app/ImportContact" component={ImportContact}/>
<Route path="/app/MenuSideWeb" component={MenuSideWeb}/>
<Route path="/app/dashboard" component={Dashboardnew}/>
<Route path="/app/profile" component={Profile}/>
<Route path="/app/addbalance" component={AddBalance}/>
<Route path="/app/addsubadmin" component={ViewForm}/>
<Route path="/app/contact" component={Contact}/>
<Route path="/app/group" component={Group}/>
<Route path="/app/category" component={Category}/>
<Route path="/app/bulk" component={BulkSMS}/>
<Route path="/app/request" component={Request}/>
<Route path="/app/Menu" component={Menutest}/>
<Route path="/app/CMS" component={MenuSideWebCMS}/>
<Route path="/app/AddGroup" component={AddGroup}/>
<Route path="/app/EditGroup" component={EditGroup}/>
<Route path="/app/AddCategory" component={AddCategory}/>
<Route path="/app/EditCategory" component={EditCategory}/>
<Route path="/app/Setting" component={Settings}/>
<Route path="/app/IntegrationSMS" component={IntegrationSMS}/>
<Route path="/app/LBA" component={LBA}/>
<Route path="/app/Profiled" component={Profiled}/>
<Route path="/app/editor" component={EditorConvertToHTML} />
<Route path="/app/Map" component={Map }/>
<Route path ="/app/MyMap" component={MyMap} />
<Route path ="/app/GoogelUser" component={GoogelUser} />
<Route path ="/app/InternationalSMS" component ={InternationalSMS} />
<Route path ="/app/AddArea" component ={AddArea} />
<Route path ="/app/Invoices" component ={Invoices} />
<Route path ="/app/SubAdminJobs" component ={SubAdminJobs} />
<Route path ="/app/JobsHistory" component ={JobsHistory} />
<Route path ="/app/MigrationData" component ={MigrationData} />
<Route path ="/app/JobDetails" component={JobDetails}/>




<Route path="/app/" exact component={Login}/>
<Redirect from="/" to="/app/" />
<Redirect from="/app" to="/app/" />
</Switch>
</div>
</BrowserRouter>
</Provider>
);

serviceWorker.unregister();



//teest comment
